module.exports = __webpack_public_path__ + "img/logbig.d5a4532f.png";